import _ from 'lodash';
/**
 * NOTE: The reason memoization is used is to avoid multiple instantiations by the factory functions.
 */
export default class SdkReduxConfig {
    constructor() {
        this.memoizedFrameworkFactories = new Map();
        this.memoizedSignerFactories = new Map();
    }
    static getOrCreateSingleton() {
        if (!globalThis.sdkReduxConfig) {
            globalThis.sdkReduxConfig = new SdkReduxConfig();
        }
        return globalThis.sdkReduxConfig;
    }
    getRpcApiSlice() {
        if (!this.rpcApiSlice) {
            throw Error('The RpcApiSlice has not been set. Are you sure you initialized SDK-Redux properly?');
        }
        return this.rpcApiSlice;
    }
    getSubgraphApiSlice() {
        if (!this.subgraphApiSlice) {
            throw Error('The SubgraphApiSlice has not been set. Are you sure you initialized SDK-Redux properly?');
        }
        return this.subgraphApiSlice;
    }
    getFramework(chainId) {
        const frameworkFactory = this.memoizedFrameworkFactories.get(chainId);
        if (!frameworkFactory)
            throw Error(`Don't know how to get Superfluid Framework. :( Please set up a *framework* source for chain [${chainId}].`);
        return frameworkFactory();
    }
    getSigner(chainId) {
        const signerFactory = this.memoizedSignerFactories.get(chainId);
        if (!signerFactory)
            throw Error(`Don't know how to get a signer. :( Please set up a *signer* source for chain [${chainId}].`);
        return signerFactory();
    }
    getTransactionTrackerSlice() {
        if (!this.transactionTrackerSlice) {
            throw Error('The TransactionTrackerSlice has not been set. Are you sure you initialized SDK-Redux properly?');
        }
        return this.transactionTrackerSlice;
    }
    setRpcApiSlice(slice) {
        if (this.rpcApiSlice) {
            console.log("Warning! RpcApiSlice was already set and will be overriden. This shouldn't be happening in production.");
        }
        this.rpcApiSlice = slice;
    }
    setSubgraphApiSlice(slice) {
        if (this.subgraphApiSlice) {
            console.log("Warning! SubgraphApiSlice was already set and will be overriden. This shouldn't be happening in production.");
        }
        this.subgraphApiSlice = slice;
    }
    setFramework(chainId, instanceOrFactory) {
        const frameworkFactory = isFramework(instanceOrFactory)
            ? () => Promise.resolve(instanceOrFactory)
            : instanceOrFactory;
        this.memoizedFrameworkFactories.set(chainId, _.memoize(frameworkFactory));
    }
    setSigner(chainId, instanceOrFactory) {
        const signerFactory = isEthersSigner(instanceOrFactory)
            ? () => Promise.resolve(instanceOrFactory)
            : instanceOrFactory;
        this.memoizedSignerFactories.set(chainId, _.memoize(signerFactory));
    }
    setTransactionTrackerSlice(slice) {
        if (this.transactionTrackerSlice) {
            console.log("Warning! TransactionTrackerSlice was already set and will be overriden. This shouldn't be happening in production.");
        }
        this.transactionTrackerSlice = slice;
    }
}
export const getConfig = SdkReduxConfig.getOrCreateSingleton;
export const getRpcApiSlice = () => getConfig().getRpcApiSlice();
export const getSubgraphApiSlice = () => getConfig().getSubgraphApiSlice();
export const getTransactionTrackerSlice = () => getConfig().getTransactionTrackerSlice();
export const getFramework = (chainId) => getConfig().getFramework(chainId);
export const getSubgraphClient = (chainId) => getConfig()
    .getFramework(chainId)
    .then((x) => x.query.subgraphClient);
export const getSigner = (chainId) => getConfig().getSigner(chainId);
const isEthersSigner = (value) => !!value.getAddress;
const isFramework = (value) => !!value.cfaV1;
//# sourceMappingURL=sdkReduxConfig.js.map